import { Component, ElementRef, Inject, OnDestroy, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { FirebaseMessagingService } from './services/core/notification/firebase-messaging.service';
import { ReminderAlertService } from './modules/shared/reminders/services/reminder-alert.service';
import { BrowserNotificationService } from './modules/shared/reminders/services/browser-notification.service';
import { RealtimeSessionService } from './services/realtime/realtime-session.service';
import { UserService } from './services/core/user.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnDestroy {
  title = 'angular-app';

  public constructor(
    private router: Router,
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private firebaseMessagingService: FirebaseMessagingService,
    private reminderAlertService: ReminderAlertService,
    private browserNotificationService: BrowserNotificationService,
    private realtimeSession: RealtimeSessionService,
    private currentUser: UserService
  ) {
    // this.document.body.classList.add('sidebar-pinned');
    //  this.router.navigate(['auth/login']);
    this.loadGoogleMapsApi();
  }

  ngOnInit(): void {
    this.firebaseMessagingService
      .requestPermissionAndGetToken()
      .then((token) => {
        if (token) {

          console.log('FCM Token:', token);
        }
      });
    this.firebaseMessagingService.listenForMessages();

    // ========== Outlook-Style Reminder Alerts ==========
    // Request browser notification permission
    this.browserNotificationService.requestPermission().then(granted => {
      if (granted) {
        console.log('[App] Browser notifications enabled for reminders');
      } else {
        console.warn('[App] Browser notifications denied - alerts will show without browser notifications');
      }
    });

    // Initialize smart scheduler system (timer-based, no polling)
    this.reminderAlertService.initialize();
    console.log('[App] Smart reminder scheduler initialized');

    // Real-time Signal Bus + permission sync: reconnect this session to its
    // office-family feed if already logged in (covers reload-while-logged-in).
    // Fresh login, logout, 401 and office-switch drive RealtimeSessionService
    // directly from their own flows. Nothing reaches RTDB until the backend
    // kill-switch (FIREBASE_SIGNALS_ENABLED) is on.
    if (this.currentUser.isLoggedIn()) {
      this.realtimeSession.resume();
    }
  }

  ngOnDestroy(): void {
    // Stop background sync when app is destroyed
    this.reminderAlertService.stopSync();
    console.log('[App] Reminder scheduler stopped');
  }

  loadGoogleMapsApi() {
    const win = window as any;
    // If Google Maps is already loaded or a script is already present, do nothing
    if (win.google?.maps) {
      return;
    }
    const existing = Array.from(document.getElementsByTagName('script')).some(s => s.src && s.src.includes('maps.googleapis.com/maps/api/js'));
    if (existing) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapApi}&libraries=places,drawing,geometry`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
